import { useFocusEffect, useNavigation } from '@react-navigation/native'
import { useCallback } from 'react'

export default function useEnableBottomNavigation() {
  const navigation = useNavigation()

  useFocusEffect(
    useCallback(() => {
      navigation.getParent()?.setOptions({ tabBarStyle: { display: 'flex' } })
    }, [navigation])
  )
}
